export class NavbarItem {
	href: string;
	display: string;
	show: boolean;
	isExternalUrl = false;
	isDropdownButton = false;
	dropdownItems: Array<NavbarItem>;

	constructor(
		href: string,
		display: string,
		show: boolean,
		isExternalUrl?: boolean,
		isDropdownButton?: boolean,
		dropdownItems?: Array<NavbarItem>
	) {
		this.href = href;
		this.display = display;
		this.show = show;
		this.isExternalUrl = isExternalUrl;
		this.isDropdownButton = isDropdownButton;
		this.dropdownItems = dropdownItems;
	}
}
